import { validate } from 'uuid'
import { isWindowEnv } from 'utils/env.utils'

/**
 * Partner session utility functions for Web SDK session handling
 * Shared across shop and cabinet apps
 */

/**
 * Validates if a string is a valid UUID format
 */
export function isValidSessionId(sessionId: string | null | undefined): boolean {
  if (!sessionId || typeof sessionId !== 'string') {
    return false
  }
  return validate(sessionId)
}

/**
 * Extracts session_id from URL query parameters
 */
export function getSessionIdFromUrl(): string | null {
  if (!isWindowEnv()) return null

  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('session_id')
}

/**
 * Storage key for partner context
 */
export const PARTNER_CONTEXT_STORAGE_KEY = 'elo_partner_context'
